import React from "react";
import { useNavigate } from "react-router-dom";
import svg10 from "../../../../assets/svg/svg10.svg";

const Step = ({ number, title, desc, mt, showCircle }) => (
  <div className="relative flex-1" style={{ marginTop: mt }}>
    {showCircle && (
      <div className="absolute right-[5rem] -top-[3rem] w-[20rem] h-[20rem] rounded-full bg-[#F5F8FF] pointer-events-none z-0" />
    )}
    <div className="relative">
      <div className="flex items-center gap-[.5rem] mb-[.75rem]">
        <div className="w-[1.4375rem] h-[1.4375rem] rounded-[0.625rem] bg-[#C4C4C4] flex-shrink-0" />
        <div className="w-[2rem] h-[0.125rem] bg-[#DB2A12]" />
      </div>
      <div className="relative">
        <div className="text-[#000] font-lexend text-[1.125rem] font-[600] leading-[1.625rem] tracking-[-0.0135rem] relative z-10">
          {title}
        </div>
        <div className="mt-[.5rem] text-[#7A7493] font-lexend text-[1rem] font-[400] leading-[1.625rem] tracking-[-0.012rem] relative z-10">
          {desc}
        </div>
        <div className="absolute -bottom-[2rem] right-[15rem] text-[#EFEFEF] font-interSans text-[12.75rem] font-[900] leading-[12.75rem] tracking-[-0.255rem] select-none pointer-events-none z-0">
          {number}
        </div>
      </div>
    </div>
  </div>
);

function HowNdovuWorks({ how }) {
  const navigate = useNavigate();

  const row1 = how?.steps?.slice(0, 3) ?? [];
  const row2 = how?.steps?.slice(3, 6) ?? [];

  return (
    <div className="lg:px-[5.69rem] px-3 py-[4rem] lg:py-[5rem]">
      {/* Desktop layout */}
      <div className="hidden lg:block">
        <div className="max-w-[50rem]">
          <div className="text-[#000] font-lexend text-[3rem] font-[600] leading-[3.375rem] tracking-[-0.06rem]">
            {how?.title}
          </div>
          <div className="mt-[.75rem] lg:max-w-[35rem] w-full text-[#7A7493] font-lexend text-[1.125rem] font-[500] leading-[1.625rem] tracking-[-0.0135rem]">
            {how?.subtitle}
          </div>
          <div className="mt-[1.5rem]">
            <button
              className="cstm-btn-2 !w-auto !min-w-0 group transition-all duration-500 ease-in-out"
              onClick={() => navigate("/request-demo")}
            >
              Request a demo
              <img
                src={svg10}
                alt="arrow"
                className="w-4 h-3 overflow-hidden opacity-0 group-hover:w-[1.25rem] group-hover:opacity-100 group-hover:ml-[.375rem] transition-all duration-500 ease-in-out"
              />
            </button>
          </div>
        </div>

        {/* Row 1 — staircase 1,2,3 */}
        <div className="mt-[3rem] flex flex-row items-start gap-[3rem]">
          {row1.map((s) => <Step key={s.number} {...s} showCircle={s.number === "3"} />)}
        </div>

        {/* Row 2 — staircase 4,5,6 */}
        <div className="mt-[4rem] flex flex-row items-start gap-[3rem]">
          {row2.map((s) => <Step key={s.number} {...s} />)}
        </div>
      </div>

      {/* Mobile layout */}
      <div className="lg:hidden">
        <div className="max-w-[28rem]">
          <div className="text-[#000] font-lexend text-[2rem] font-[600] leading-tight tracking-[-0.06rem]">
            {how?.title}
          </div>
          <div className="mt-[.75rem] text-[#7A7493] font-lexend text-[1.125rem] font-[500] leading-[1.625rem] tracking-[-0.0135rem]">
            {how?.subtitle}
          </div>
          <div className="mt-[1.5rem]">
            <button
              className="cstm-btn-2 !w-auto !min-w-0 group transition-all duration-500 ease-in-out"
              onClick={() => navigate("/request-demo")}
            >
              Request a demo
              <img
                src={svg10}
                alt="arrow"
                className="w-4 h-3 overflow-hidden opacity-0 group-hover:w-[1.25rem] group-hover:opacity-100 group-hover:ml-[.375rem] transition-all duration-500 ease-in-out"
              />
            </button>
          </div>
        </div>

        <div className="mt-[3rem] flex flex-col gap-[3rem]">
          {[...row1, ...row2].map((s) => (
            <div key={s.number} className="relative pt-[2.5rem]">
              <div className="absolute top-0 left-0 text-[#F0F0F0] font-lexend text-[7rem] font-[700] leading-none select-none pointer-events-none">
                {s.number}
              </div>
              <div className="relative z-10 flex items-center gap-[.5rem] mb-[.75rem]">
                <div className="w-[1.4375rem] h-[1.4375rem] rounded-[0.625rem] bg-[#C4C4C4] flex-shrink-0" />
                <div className="w-[2rem] h-[0.125rem] bg-[#DB2A12]" />
              </div>
              <div className="relative z-10">
                <div className="text-[#202020] font-lexend text-[1.125rem] font-[600] leading-[1.625rem] tracking-[-0.0135rem]">{s.title}</div>
                <div className="mt-[.5rem] text-[#7A7493] font-lexend text-[1rem] font-[400] leading-[1.625rem]">{s.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HowNdovuWorks;
